var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Avatar from '../avatar';
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { SkeletonImage } from '../skeleton/image';
import { Description } from '../description/description';
import { shadow } from '../theme/shadow';
const getMaxHeight = (size = 'lg') => {
    const heights = {
        md: {
            width: 164,
            headerHeight: 50,
        },
        lg: {
            width: 344,
            headerHeight: 100,
        },
    };
    return heights[size] || heights.lg;
};
const StyledCard = styled.div `
  width: ${(props) => `${getMaxHeight(props.size).width}px`};
  height: ${(props) => `${getMaxHeight(props.size).width}px`};
  border-radius: 20px;
  background-color: ${() => 'var(--bg-color)'};
  ${(props) => (props.shadow ? props.shadow : shadow.lg)};

  div[data-role='card-header'] {
    background-color: ${() => 'var(--bg-color-1)'};
    border-radius: 20px 20px 0px 0px;
    width: 100%;
    height: ${(props) => `${getMaxHeight(props.size).headerHeight}px`};
    box-sizing: border-box;
    padding: 12px;
    display: flex;
    align-items: center;

    .card-title {
      display: flex;
      flex-direction: column;
      margin-left: 8px;
    }
  }

  [data-role='card-title'] {
    margin: 0px;
  }

  .card-body {
    padding: 12px;
  }
`;
const StyledCardTitle = styled(Description) `
  margin-left: 8px;
  [data-role='title'] {
    margin: 0px;
  }
`;
const IfElse = (props) => {
    if (props.loading) {
        return React.createElement(React.Fragment, null, props.loadingComponent);
    }
    if (props.if) {
        return React.createElement(React.Fragment, null, props.children);
    }
    return React.createElement(React.Fragment, null, props.else);
};
export const Card = (_a) => {
    var { shadow = 'lg', title, subTitle } = _a, props = __rest(_a, ["shadow", "title", "subTitle"]);
    return (React.createElement(StyledCard, Object.assign({ className: cx('card', props.className), "data-role": "card", shadow: shadow }, props),
        React.createElement("div", { className: "card-header", "data-role": "card-header" },
            React.createElement(IfElse, { if: !!props.src, loading: props.loading, loadingComponent: React.createElement(SkeletonImage, null) },
                React.createElement(Avatar, { type: "md", src: props.src })),
            React.createElement(StyledCardTitle, { title: title, content: subTitle })),
        React.createElement("div", { className: "card-body", "data-role": "card-body" }, props.children)));
};
